/* eslint no-console:0 */
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import * as ActiveStorage from "@rails/activestorage"
import {} from "../semantic-ui-init"
import {} from "../dropdown"

const application = Application.start()
const context = require.context('./../controllers', true, /\.js$/)
application.load(definitionsFromContext(context))

ActiveStorage.start()
